import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CancellableCrudService } from './cancellable-crud.service';
import { IRemoteCommunication } from 'projects/common/src/app/interfaces/communication';
import ipRegex from 'ip-regex';
import { ServerConfigService } from 'src/app/services/server-config.service';

/**
 * Define métodos para comunicación con el servidor remoto.
 */
@Injectable({
  providedIn: 'root'
})
export class ApiService extends CancellableCrudService implements IRemoteCommunication {

  constructor(
    protected http: HttpClient,
    protected configServer: ServerConfigService
  ) {
    super(http, configServer);

    // if (typeof host === 'string') {
    //   if (ipRegex({exact: true}).test(host)) {
    //     this.config.host = host;
    //   } else {
    //     // TODO ERROR: INVALID_PARAMETER_FORMAT_EXPECTED_DEFAULT
    //     this.error(`Formato de parámetro invalido [%s]. Se utilizará el valor por defecto [%s]`, host, this.config.host);
    //   }
    // }
    // if (typeof port === 'string' || typeof port === 'number') {
    //   this.config.port = port.toString();
    // } else {
    //   // TODO ERROR: INVALID_PARAMETER_VALUE_DEFAULT
    //   this.error(`Valor invalido [%s]. Se utilizará el valor por defecto [%s].`, port, this.config.port);
    // }
  }
}
